import React from 'react';
import { BarChart, Box, Text } from '@common-fe/common-fe';

import EmployerSectionPlaceholder from '../EmployerSectionPlaceholder';

import { EmployerClaimSpendPreloader, EmployerClaimSpendTitle } from './components';
import { useGetClaimSpendQuery } from './queries';

interface Props {
  isLoading?: boolean;
  planId: string;
}
const OVERFLOW_COUNT = 11;
const EmployerClaimSpendNotionalContainer: React.FC<Props> = ({ isLoading, planId }) => {
  const {
    isLoading: queryIsLoading,
    isError,
    refetch,
    data,
    total,
    currentIndex,
    isSuccess,
  } = useGetClaimSpendQuery(planId, {
    disabled: isLoading,
  });

  if ((!isSuccess && !isError) || isLoading || queryIsLoading) {
    return <EmployerClaimSpendPreloader isHSA={false} isLoading />;
  }
  if (isError && !isLoading) {
    return (
      <EmployerSectionPlaceholder onTryAgain={refetch}>
        We couldn't load your spend data
      </EmployerSectionPlaceholder>
    );
  }

  return (
    <Box
      pad="spacing24"
      background="canvas"
      round="container2Round"
      height="256px"
      border={{ size: '1px', color: 'border2' }}
      data-testid="employer-claim-spend_loading"
    >
      <Text size="medium" weight={700} data-testid="employer-claim-spend_title">
        Claim spend
      </Text>
      <Box direction="row" height="100%" margin={{ top: 'spacing12' }}>
        {/* <Box width="190px"> */}
        <EmployerClaimSpendTitle value={total} />
        {/* </Box> */}
        <Box fill direction="row" align="end" height="100%" margin={{ left: 'spacing32' }}>
          <BarChart
            width="100%"
            currentIndex={currentIndex >= 0 ? currentIndex : undefined}
            isOverflowMode={data.length > OVERFLOW_COUNT}
            values={data}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default EmployerClaimSpendNotionalContainer;
